<ws-modal-wrapper headerLabel="Mark Load Data Complete"
                  [hideFooter]="true"
                  (cancel)="cancel()">
    <p>Are you sure you wish to mark load data complete?</p>
    <div class="modal-footer">
        <div class="ws-button-row">
            <button class="ace-btn btn-primary" (click)="complete()">OK</button>
            <button class="ace-btn btn-primary btn-danger" (click)="skip()">
                Skip
            </button>
            <button class="ace-btn btn-secondary" (click)="cancel()">Cancel</button>
        </div>
    </div>
</ws-modal-wrapper>
